import React from 'react'
import { useContext } from 'react'

import notesContext from '../context/notes/notesContext'
import AddNote from './AddNote'
import Notes from './Notes'
const Home = (props) => {
 const {showAlert} = props
  
  return (
    <div >
    
    <Notes showAlert={showAlert}/>
   
    </div>
  )
}

export default Home
